<template>
  <flickity ref="flickity" :options="options" @init="emitIndex">
    <slot></slot>
  </flickity>
</template>

<script>
import Flickity from "vue-flickity";

export default {
  components: {
    Flickity
  },
  props: {
    desktopOnly: {
      type: Boolean,
      default: false
    },
    startIndex: {
      type: Number,
      required: false
    },
    arrows: {
      type: Boolean,
      default: false
    },
    dots: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    options() {
      return {
        autoPlay: true,
        cellAlign: "left",
        contain: !this.isMobile,
        pageDots: this.dots,
        imagesLoaded: true,
        lazyLoad: 20,
        initialIndex: this.startIndex ? this.startIndex : 0,
        prevNextButtons: this.arrows,
        draggable: this.draggable
      };
    }
  },
  mounted() {
    this.resizeFunction = () => {
      if (this.$refs.flickity) {
        this.$refs.flickity.resize();
      }
    };

    this.$root.$on("viewExpanded", () => {
      this.resizeFunction();
    });

    this.$nextTick(() => {
      if (typeof window.ObserveImages === "function") {
        window.ObserveImages();
      }
      if (this.$refs.flickity) {
        this.slideImages = this.$el.querySelectorAll(".flickity-slider img");
        if (this.slideImages) {
          this.slideImages.forEach(image => {
            image.addEventListener("load", this.resizeFunction());
          });
        }
      }
    });
  },
  beforeDestroy() {
    if (this.slideImages) {
      this.slideImages.forEach(image =>
        image.removeEventListener("load", this.resizeFunction)
      );
    }
  },
  methods: {
    imgsLoaded() {
      // Reload flickity cells due to height change post
      let flickityInstance = this.$refs.flickity;
      flickityInstance.reloadCells();
    },
    emitIndex() {
      this.$nextTick(() => {
        if (this.$refs.flickity) {
          this.$refs.flickity.on("change", index => {
            this.$emit("change", index);
          });
        }
      });
    }
  }
};
</script>
